import React, { useState } from 'react';
import ToggleButton from 'components/ToggleButton/ToggleButton';
import { useSelector } from 'react-redux';
import { allowPermanentMeetingsSetting } from 'selectors/accountSelectors';
import intl from 'react-intl-universal';
import useSettingsChange from 'hooks/useSettingsChange';
import SettingToggleTooltip from './SettingToggleTooltip';
import { ACCOUNT_SETTING_ALLOW_PERMANENT_MEETINGS } from 'constants/accountSettingsConstants';
import { selectAccountPermissions } from 'selectors/permissionsSelector';
import { ROLE_PERMISSION } from 'interfaces/Role';

export interface Props {
  setSettingsChangeError: Function;
}

const AllowPermanentMeetings = (props: Props) => {
  const { setSettingsChangeError } = props;
  const allowPermanentMeetings = useSelector(allowPermanentMeetingsSetting);
  const [ allowPermanentMeetingState, setAllowPermanentMeetingState ] = useState(allowPermanentMeetings);
  const canEditSettings = useSelector(selectAccountPermissions)[ROLE_PERMISSION.MODIFY_OWN_ACCOUNT_GENERAL_SETTINGS];

  const changeSettings = useSettingsChange();

  return (
    <ToggleButton
      classNameLabel={''}
      id={ACCOUNT_SETTING_ALLOW_PERMANENT_MEETINGS}
      label={<SettingToggleTooltip label={intl.get('allowPermanent')} tipLabel={intl.get('allowPermanentTip')} />}
      leftLabel={false}
      hidenow={false}
      topLabel={false}
      disabled={!canEditSettings}
      field={{
        name: ACCOUNT_SETTING_ALLOW_PERMANENT_MEETINGS,
        value: allowPermanentMeetingState,
        onChange: () => {
          if (!canEditSettings) { return; }
          return changeSettings(
            ACCOUNT_SETTING_ALLOW_PERMANENT_MEETINGS,
            setAllowPermanentMeetingState,
            allowPermanentMeetingState,
            setSettingsChangeError
          );
        },
        onBlur: () => { return; }
      }}
    />
  );
};

export default AllowPermanentMeetings;
